export const environment = {
  production: false,
  apiUrl: '/api/v2',
  socketIoHost: '',
};
